import LoadingRegion from './LoadingRegion';
import SkeletonBone from './SkeletonBone';

function TableSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950/70">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-slate-50/80 px-3 py-2.5 dark:border-slate-800 dark:bg-slate-900/50">
        <SkeletonBone className="h-5 w-14" rounded="rounded-md" />
        <SkeletonBone className="h-3 w-28" />
        <SkeletonBone className="ml-auto h-3 w-16" />
      </div>
      <div className="space-y-2.5 p-3">
        {Array.from({ length: 7 }, (_, index) => (
          <div key={index} className="flex items-center gap-3">
            <SkeletonBone className={`h-3.5 ${index % 3 === 0 ? 'w-16' : 'w-14'}`} />
            <SkeletonBone className="ml-auto h-3.5 w-10" />
            <SkeletonBone className="h-3.5 w-10" />
            <SkeletonBone className="h-3.5 w-8" />
          </div>
        ))}
      </div>
    </div>
  );
}

const CHART_BAR_HEIGHTS = ['h-10', 'h-16', 'h-12', 'h-20', 'h-14', 'h-24', 'h-11', 'h-16', 'h-20', 'h-12'];

function ChartSkeleton() {
  return (
    <div className="flex min-h-[14rem] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950/70">
      <div className="border-b border-slate-200 px-3 py-2 dark:border-slate-800">
        <SkeletonBone className="h-3.5 w-32" />
        <SkeletonBone className="mt-1.5 h-3 w-24" />
      </div>
      <div className="flex flex-1 items-end gap-1.5 p-3">
        {CHART_BAR_HEIGHTS.map((heightClass, index) => (
          <SkeletonBone key={index} className={`flex-1 ${heightClass}`} rounded="rounded-sm" />
        ))}
      </div>
    </div>
  );
}

function BlockSkeleton() {
  return (
    <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_minmax(16rem,22rem)] lg:items-stretch">
      <TableSkeleton />
      <ChartSkeleton />
    </div>
  );
}

/** Skeleton for Версии page while UK / stats reload. */
export default function StatusVersionsSkeleton() {
  return (
    <LoadingRegion label="Загрузка версий">
      <div className="space-y-4" aria-hidden="true">
        <SkeletonBone className="h-3 w-48" />
        <BlockSkeleton />
        <BlockSkeleton />
      </div>
    </LoadingRegion>
  );
}
